import * as React from 'react';
import { ThemeProvider, type Theme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { baseTheme } from './themes/BaseTheme/BaseTheme';

export type AppColorScheme = 'light' | 'dark' | 'system';

export interface AppThemeProps {
  children: React.ReactNode;
  theme?: Theme;
  defaultMode?: AppColorScheme;
}

export function AppTheme({
  children,
  defaultMode = 'system',
  theme = baseTheme,
}: AppThemeProps) {
  return (
    <ThemeProvider theme={theme} defaultMode={defaultMode}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
